import request from '@utils/axiosWrapper';

/** 退出登录 */
const doLogout = () => {
    // proxy踢登
    if (window.CommConstants && window.CommConstants.eappBaseUrl) {
        request.postAsFormSubmit(
            `${window.CommConstants.eappBaseUrl}/clear_proxy_cookie_when_waimai_e_logout`,
            {},
            { withCredentials: true },
        );
    }

    // eslint-disable-next-line waimaie/no-direct-access-localstorage
    localStorage.removeItem('exceptionType');
    setTimeout(function() {
        if (window && window.top) {
            window.top.location.href = '/logout';
        }
    }, 500);
};

export default doLogout;
